import { observer } from "mobx-react-lite";
import { useApp } from "../context";

import { Navigate, Route, Routes } from "react-router";

import { Home } from "./gamemodes/Home";
import { Resume } from "./gamemodes/Resume";
import { Completed } from "./gamemodes/Completed";
import { AnalyticRoot } from "./gamemodes/analytic/Root";
import { AnalyticMeta } from "./gamemodes/analytic/Meta";
import { AnalyticFinish } from "./gamemodes/analytic/Finish";
import { AnalyticQuestions } from "./gamemodes/analytic/Questions";
import { GameRoute } from "./gamemodes/game/GameRoute";
import { DailyRoute } from "./gamemodes/daily/DailyRoute";
import { SurvivalRoute } from "./gamemodes/survival/SurvivalRoute";

import { ReportRoute } from "./ReportRoute";

import { AdminAudioDonationRoute } from "./AdminAudioDonationRoute";
import { AdminBenchmarkRoute } from "./AdminBenchmarkRoute";
import { AdminCategoryEditRoute } from "./AdminCategoryEditRoute";
import { AdminCategoryRoute } from "./AdminCategoryRoute";
import { AdminContactsRoute } from "./AdminContactsRoute";
import { AdminHomeRoute } from "./AdminHomeRoute";
import { AdminQuestionBatchUploadRoute } from "./AdminQuestionBatchUploadRoute";
import { AdminQuestionEditRoute } from "./AdminQuestionEditRoute";
import { AdminQuestionRoute } from "./AdminQuestionRoute";
import { AdminUserRoute } from "./AdminUserRoute";
import { AuthRequiredRoute } from "./AuthRequiredRoute";

import { LoginRoute } from "./LoginRoute";
import { LogoutRoute } from "./LogoutRoute";

import { AdminAudioDatasetRoute } from "./AdminAudioDatasetRoute";
import { AdminUserEditRoute } from "./AdminUserEditRoute";
import { DataDonationRoute } from "./DataDonationRoute";
import { NotFoundRoute } from "./NotFoundRoute";
import { PrivacyPolicyDataDonationRoute } from "./PrivacyPolicyDataDonationRoute";
import { PrivacyPolicyGameRoute } from "./PrivacyPolicyGameRoute";

export const Router = observer(function Router() {
  const app = useApp();

  return (
    <Routes>
      <Route path="" element={<Navigate to="/benchmark" replace />} />
      <Route path="login" element={<LoginRoute />} />
      <Route path="logout" element={<LogoutRoute />} />
      <Route path="auth-required" element={<AuthRequiredRoute />} />
      <Route path="privacy-policy-game" element={<PrivacyPolicyGameRoute />} />
      <Route
        path="privacy-policy-data-donation"
        element={<PrivacyPolicyDataDonationRoute />}
      />

      <Route path="benchmark" element={<Home />} />
      {app.benchmarks.isModeEnabled("game") && (
        <Route path="benchmark/game" element={<GameRoute />} />
      )}
      {app.benchmarks.isModeEnabled("daily") && (
        <Route path="benchmark/daily" element={<DailyRoute />} />
      )}
      {app.benchmarks.isModeEnabled("survival") && (
        <Route path="benchmark/survival" element={<SurvivalRoute />} />
      )}
      <Route path="benchmark/finished" element={<Completed />} />
      <Route path="data-donation" element={<DataDonationRoute />} />
      {app.benchmarks.isModeEnabled("analytic") && (
        <Route path="benchmark/analytic" element={<AnalyticRoot />}>
          <Route path="" element={<Navigate to="/benchmark/analytic/questions" replace />} />
          <Route path="meta" element={<AnalyticMeta />} />
          <Route path="finish" element={<AnalyticFinish />} />
          <Route path="questions" element={<AnalyticQuestions />} />
        </Route>
      )}

      <Route
        path="benchmark/resume/:id/:secret"
        element={<Resume />}
      />

      <Route path="report/:id/:secret" element={<ReportRoute />} />

      <Route path="admin" element={<AdminHomeRoute />}>
        <Route path="" element={<Navigate to="/admin/users" />} />
        <Route path="benchmarks" element={<AdminBenchmarkRoute />} />
        <Route path="contacts" element={<AdminContactsRoute />} />
        <Route path="users" element={<AdminUserRoute />}>
          <Route path="edit/:id" element={<AdminUserEditRoute />} />
        </Route>
        <Route path="question" element={<AdminQuestionRoute />}>
          <Route path="edit/:id" element={<AdminQuestionEditRoute />} />
          <Route
            path="batch-upload"
            element={<AdminQuestionBatchUploadRoute />}
          />
        </Route>
        <Route path="audio-donations" element={<AdminAudioDonationRoute />} />
        <Route path="category" element={<AdminCategoryRoute />}>
          <Route path="edit/:id" element={<AdminCategoryEditRoute />} />
        </Route>
        <Route path="dataset" element={<AdminAudioDatasetRoute />} />
      </Route>

      <Route path="*" element={<NotFoundRoute />} />
    </Routes>
  );
});
